import React, { Component, PropTypes } from 'react';
import TcDayPickerSet from '../../../../tc-ui/date-picker-set';
import { FontIcon } from 'material-ui';
import DateUtils from '../../../../../utils/date-utils';
import R from 'ramda';

const propTypes = {
  prevDREnd: PropTypes.any,
  renderDay: PropTypes.func,
  selectedSeasonName: PropTypes.string,
  seasonIndex: PropTypes.number,
  index: PropTypes.number,
  contractingPeriod: PropTypes.object,
  range: PropTypes.object,
  onChange: PropTypes.func,
  onUpdate: PropTypes.func,
  onDelete: PropTypes.func,
  onAdd: PropTypes.func,
};
class StartEndDate extends Component {
  shouldComponentUpdate(nextProps) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps));
  }

  render() {
    const {
      prevDREnd,
      renderDay,
      selectedSeasonName,
      seasonIndex,
      index,
      contractingPeriod,
      range,
      onChange,
      onUpdate,
      onAdd,
      onDelete,
    } = this.props;

    const currentFromDate = R.prop('seasonStartDate', range);
    const currentToDate = R.prop('seasonEndDate', range);
    const initialStartDateMonth = (() => {
      if (currentFromDate) return currentFromDate;
      if (currentToDate) return currentToDate;
      if (prevDREnd) return prevDREnd;
      return contractingPeriod.startDate;
    })();
    const initialEndDateMonth = (() => {
      if (currentToDate) return currentToDate;
      if (currentFromDate) return currentFromDate;
      if (prevDREnd) return prevDREnd;
      return contractingPeriod.startDate;
    })();
    const isSpecialEvent = selectedSeasonName.toLowerCase() === 'special event';
    const notInContractPeriod =
      range.seasonStartDate &&
      range.seasonEndDate &&
      DateUtils.notInContractingPeriod(
        [range],
        contractingPeriod.startDate,
        contractingPeriod.endDate,
      );
    return (
      <div>
        <TcDayPickerSet
          key={index}
          style={{ display: 'flex', width: '95%' }}
          showTextField={isSpecialEvent}
          endDateCloseOnSelect
          startDateCloseOnSelect
          textFieldStyle={{ display: 'inline-block', width: '100px', fontSize: '12px' }}
          startDateContainerStyle={{ display: 'inline-block', marginLeft: '8px', width: 'calc(50% - 80px)' }}
          startDateTextFieldStyle={{ width: '100%', fontSize: '12px' }}
          endDateContainerStyle={{ display: 'inline-block', width: 'calc(50% - 80px)' }}
          endDateTextFieldStyle={{ width: '100%', fontSize: '12px' }}
          addButtonStyle={{ marginLeft: '8px', lineHeight: '24px', verticalAlign: 'middle' }}
          deleteButtonStyle={{ lineHeight: '24px', verticalAlign: 'middle' }}
          textFieldFloatingText="Event Name"
          startDateFloatingText="Start Date"
          endDateFloatingText="End Date"
          renderDay={renderDay(false)}
          initialStartDateMonth={initialStartDateMonth}
          startDateEnableFrom={contractingPeriod.startDate}
          startDateEnableTo={contractingPeriod.endDate}
          initialEndDateMonth={initialEndDateMonth}
          endDateEnableFrom={contractingPeriod.startDate}
          endDateEnableTo={contractingPeriod.endDate}
          textFieldValue={range.eventName}
          startDate={range.seasonStartDate}
          endDate={range.seasonEndDate}
          startDateUnderlineStyle={notInContractPeriod ? { borderColor: 'red' } : {}}
          endDateUnderlineStyle={notInContractPeriod ? { borderColor: 'red' } : {}}
          textFieldOnChange={e =>
            onChange({
              keyPath: ['data', 'existingSeasons', seasonIndex, 'dateRanges', index, 'eventName'],
              value: e.target.value,
            })
          }
          onChangeStartDate={value =>
            onUpdate({
              eventName: range.eventName,
              seasonStartDate: value || range.seasonEndDate,
              seasonEndDate: range.seasonEndDate,
            })
          }
          onChangeEndDate={value =>
            onUpdate({
              eventName: range.eventName,
              seasonStartDate: range.seasonStartDate,
              seasonEndDate: value || range.seasonStartDate,
            })
          }
          onDelete={onDelete}
          onAdd={onAdd}
        />
        {notInContractPeriod ? (
          <div
            style={{
              color: '#f44336',
              fontSize: '12px',
              display: 'flex',
              width: '100%',
              alignItems: 'center',
            }}
          >
            <FontIcon className="tc-icon-report" style={{ color: '#f44336', marginRight: '4px' }} />
            Not in contracting period, please UPDATE or REMOVE
          </div>
        ) : (
          <span />
        )}
      </div>
    );
  }
}

StartEndDate.propTypes = propTypes;
export default StartEndDate;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/edit-seasons/start-end-date.jsx